/**
 * Texts for User Training page - Polish
 */
export const userTrainingPageText = {
    title: 'Szkolenie użytkownika - CamAPS FX',
    titleMeta: 'Kompleksowe zasoby szkoleniowe dla użytkowników CamAPS FX',
    descriptionMeta: 'Dostęp do kompletnych materiałów szkoleniowych, samouczków wideo, podręczników użytkownika i webinarów, aby jak najlepiej wykorzystać CamAPS FX.',
    keywords:
        'camaps fx szkolenie użytkownika, szkolenie camaps, szkolenie cukrzyca, szkolenie pompa insulinowa, podręcznik użytkownika, samouczki wideo',
    localeMeta: 'pl_pl',

    mainHeader: 'Szkolenie użytkownika',
    mainSubHeader: 'Ukończ niezbędne szkolenie w aplikacji przed użyciem aplikacji CamAPS FX.',

    gettingStartedHeader: 'Rozpoczęcie',
    step1Title: '<strong>Krok 1:</strong><br/>Pobierz aplikację',    
    step2Title: '<strong>Krok 2:</strong><br/>Utwórz konto',
    step3Title: '<strong>Krok 3:</strong><br/>Rozpocznij niezbędne szkolenie w aplikacji',
    step4Title: '<strong>Krok 4:</strong><br/>Sparuj z wybraną pompą i CGM (za zgodą zespołu opieki zdrowotnej) lub poznaj aplikację w <strong>trybie wirtualnym</strong>',
    videoSrc: '/video/In-app training loop_1.mp4', // Path to video in public folder

    supportSectionTitle: 'Potrzebujesz pomocy w instalacji aplikacji?',
    supportSectionText: 'Odwiedź naszą sekcję wsparcia, aby uzyskać pomoc',
    supportButtonText: 'WSPARCIE',
    findOutMoreButtonText: 'DOWIEDZ SIĘ WIĘCEJ',

    additionalResourcesTitle: 'Dodatkowe zasoby',
    additionalResourcesSubtitle: 'Ucz się poprzez krok po kroku wizualizacje lub oglądaj sesje prowadzone przez ekspertów na temat korzystania z aplikacji.',
    
    animationsTitle: 'Animacje',
    animationsDescription: 'Pompa insulinowa Dana jest obecnie dostępna komercyjnie wyłącznie z oprogramowaniem CamAPS FX w Wielkiej Brytanii. Wszystkie zasoby związane z Daną są zatem dostępne tylko w języku angielskim.',
    animationsLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    
    webinarsTitle: 'Webinaria',
    webinarsDescription: 'Te seminaria internetowe są przydatne dla osób z cukrzycą typu 1, ich rodzin i opiekunów, a także nauczycieli, personelu wspomagającego edukację i pracowników służby zdrowia. Oferowane są w języku angielskim.',
    webinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    factsheetsTitle: 'Arkusze informacyjne',
    factsheetsDescription: 'Pompa insulinowa Dana jest obecnie dostępna komercyjnie wyłącznie z oprogramowaniem CamAPS FX w Wielkiej Brytanii. Wszystkie zasoby związane z Daną są zatem dostępne tylko w języku angielskim.',
    factsheetsLink: 'https://www.camdiabtraining.com',

    inAppTrainingHeader: 'Szkolenie w aplikacji',
    inAppTrainingText: 'Zacznij od podstawowego szkolenia wbudowanego w aplikację CamAPS FX. To interaktywne szkolenie poprowadzi Cię przez wszystkie kluczowe funkcje, które musisz znać.<br/><br/><strong>Dostęp:</strong> Pobierz aplikację CamAPS FX i utwórz konto, aby rozpocząć szkolenie w aplikacji.',

    gettingStartedText: '<strong>Krok 1:</strong> Pobierz aplikację CamAPS FX ze sklepu z aplikacjami swojego urządzenia<br/><strong>Krok 2:</strong> Utwórz swoje konto<br/><strong>Krok 3:</strong> Ukończ moduły szkoleniowe w aplikacji<br/><strong>Krok 4:</strong> Podłącz pompę insulinową i CGM<br/><strong>Krok 5:</strong> Rozpocznij swoją podróż z CamAPS FX',

    trainingResourcesHeader: 'Dodatkowe zasoby szkoleniowe',
    videoTutorialsText: 'Samouczki wideo',
    videoTutorialsDesc: 'Obejrzyj przewodniki wideo krok po kroku obejmujące instalację, codzienne użytkowanie i rozwiązywanie problemów.',
    videoTutorialsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
    
    userGuidesText: 'Podręczniki użytkownika i dokumentacja',
    userGuidesDesc: 'Pobierz kompleksowe przewodniki PDF i materiały referencyjne.',
    userGuidesLink: 'https://www.camdiabtraining.com',
    
    webinarsText: 'Webinary na żywo',
    webinarsDesc: 'Dołącz do sesji szkoleniowych prowadzonych przez ekspertów i sesji pytań i odpowiedzi.',

    needHelpHeader: 'Potrzebujesz pomocy?',
    needHelpTextStart: 'Jeśli potrzebujesz pomocy lub masz pytania, odwiedź naszą stronę',
    supportLinkText: 'Wsparcie',
    needHelpTextEnd: 'aby uzyskać dodatkową pomoc i informacje kontaktowe.'
};

